import "./style.css";

export function MenuItem(props) {
  return (
    <div>
      <div className="text_menu">
        <p>
          <span>
            <a className="menu_text" href={props.jumpto}>
              {props.value}
            </a>
          </span>
        </p>
      </div>
    </div>
  );
}
